const actions = {
  // Listar Papéis
  listarRoles: async (context, { per_page, page }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`authorization/roles`, {
      params: {
        per_page,
        page,
      },
    });
    return response;
  },

  criarPapel: async (context, { description, display_name }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`authorization/roles`, {
      description,
      display_name,
    });
    return response;
  },

  // Listar Permissões

  listarPermissoesRole: async (context, { role_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`authorization/roles/${role_id}`);

    return response;
  },

  listarPermissoes: async (context, { per_page, nome }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`authorization/permissions`, {
      params: {
        per_page,
        nome,
      },
    });

    return response;
  },

  ativarPermissao: async (context, { permission_ids, role_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `authorization/roles/${role_id}/attach-permissions`,
      {
        permission_ids,
        action: "attach-permissions",
      }
    );

    return response;
  },
  desativarPermissao: async (context, { permission_ids, role_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `authorization/roles/${role_id}/detach-permissions`,
      {
        permission_ids,
        action: "detach-permissions",
      }
    );

    return response;
  },
};

export const perfis = {
  namespaced: true,
  actions,
};
